<div class="tooltip-container">
  <ng-content></ng-content>
</div>
